// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function UnitConverterTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Unit Converter</p>
      <p>
        Convert horticultural units across weight, volume, flow rate, small measures, and growing
        media. Results update instantly as you type.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Pick a category tab (e.g. Flow Rate, Volume, Growing Media).</li>
          <li>Enter a value and choose the from and to units.</li>
          <li>Read the converted result at the top, or tap Swap to reverse units.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Categories include</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Small measures — grams, mL, tsp, tbsp, fl oz</li>
          <li>Flow rate — GPH, GPM, L/h, mL/s</li>
          <li>Weight, volume, and bulk growing media units</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Use Common conversions for one-click presets like gallons to liters or GPH to mL/s.
      </p>
    </div>
  );
}
